<template>
	<div class="services" :class="{ 'onlyView': getPermissionAction }">
		<div class="services_block">
			<safety
					v-if="services.safety.status"
					:eld_name="eld_name"
					:eld_url="eld_url"
					:eld_login="eld_login"
					:eld_password="eld_password"
					:driver_rate="services['safety']['driver_rate']"
					:customer_rate="services['safety']['customer_rate']"
          :valid="valid"
					:driver_id="driversList['driver']['id']"
					@updateSafetyRate="onSafetyRate"
			></safety>
			<salary
					v-if="services.salary.status"
					:driverList="driverList"
					:services="services"
          :valid="valid"
					@updateSalaryRate="onSalaryRate"
			></salary>
		</div>
		<div v-if="driversList" class="services_block">
			<services-item
					:isSwitchDisabled="services.safety.customer_status"
					@updateOpenPopup="onOpenPopup"
					@updateServiceKey="onServiceKey"
					:editService="services['safety']"
					service-key="Safety"
          label="Date from"
			></services-item>
			<services-item
					:isSwitchDisabled="services.salary.customer_status"
					@updateOpenPopup="onOpenPopup"
					@updateServiceKey="onServiceKey"
					:editService="services['salary']"
					service-key="Salary"
          label="Date from"
			></services-item>
		</div>

		<dialog-info-table
				v-if="isDialog"
				:flag="flag"
				:title="title"
				:text-no-info="textNoInfo"
				:headers="headers"
				:items="items"
				width="890px"
				@updateClose="onDialogInfoTableClose"
				@updateSave="onDialogInfoTableSave"
		></dialog-info-table>

	</div>
</template>

<script>
import ServicesItem
from "@/components/Maintenance/ServicesItem/ServicesItem.vue";
import Safety from "@/components/Maintenance/Drivers/DriversForm/SecondTab/Safety/Safety.vue";
import Salary from "@/components/Maintenance/Drivers/DriversForm/SecondTab/Salary/Salary.vue";
import { driverHistorySafety } from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";
import DialogInfoTable from "@/shared/DialogInfoTable/DialogInfoTable.vue";

export default {
	name: "SecondTab",
	components: {
		DialogInfoTable,
		ServicesItem,
		Safety,
		Salary
	},
	props: {
		valid: Object,
		services: Object,
		driversList: Object,
		eld_name: String,
		eld_url: String,
		eld_login: String,
		eld_password: String,
		driverList: Array,
		payment_type: Array,
		getPermissionAction: Boolean,
	},
	data: () => ({
		isDialog: false,
		serviceKey: '',

		textNoInfo: null,
		flag: null,
		title: null,
		headers: null,
		items: null,
	}),
	methods: {
		onOpenPopup(serviceKey) {
			// Safety
			// Salary
			this.serviceKey = serviceKey;
			this.isDialog = true;

			this.flag = `${ serviceKey }History`;
			this.title = `${ serviceKey } history`;
			this.textNoInfo = 'No historical data available at the moment.';

			if (serviceKey === 'Safety') {
				this.headers = driverHistorySafety;
				this.items = this.services.safety.history;
			}
			if (serviceKey === 'Salary' ) {
				this.headers = driverHistorySafety;
				this.items = this.services.salary.history;
			}
		},
		onServiceKey({ value, date, serviceKey }) {
			this.$emit('updateServiceKey', { status: value, date, serviceKey });
		},
		onClose() {
			this.isDialog = false;
		},

		onEditServices(values) {
			this.$emit('updateEditServices', values);
		},

		onSafetyRate(value, key) {
			this.$emit('updateSafetyRate', value, key);
		},
		onSalaryRate(value, key) {
			this.$emit('updateSalaryRate', value, key);
		},

		onDialogInfoTableClose() {
			this.isDialog = false;
		},
		onDialogInfoTableSave() {
			this.isDialog = false;
		},
	}
};
</script>

<style scoped lang="scss">
@import "SecondTabDriver";
</style>
